import { db, storage } from "../firebase/config";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const uploadImage = async (file, path) => {
  try {
    if (
      typeof file === "string" &&
      file.startsWith("https://firebasestorage.googleapis.com")
    ) {
      return file;
    }

    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    console.error("Image upload error:", error);
    throw new Error("Failed to upload image");
  }
};

export const addEquipment = async (equipmentData) => {
  try {
    const { newImages, images, prices, ...rest } = equipmentData;
    const imageUrls = [...(images || [])];

    if (newImages && newImages.length > 0) {
      for (let i = 0; i < newImages.length; i++) {
        const file = newImages[i];
        if (file) {
          const path = `equipment/global/${Date.now()}_${i}`;
          const downloadURL = await uploadImage(file, path);
          imageUrls.push(downloadURL);
        }
      }
    }

    const docRef = await addDoc(collection(db, "equipment"), {
      ...rest,
      prices,
      images: imageUrls,
    });
    return { id: docRef.id, ...rest, prices, images: imageUrls };
  } catch (error) {
    console.error("Add equipment error:", error);
    throw new Error("Failed to add equipment");
  }
};

export const updateEquipment = async (id, equipmentData) => {
  if (id) {
    try {
      const updateData = { ...equipmentData }; // Start with provided data

      // Avoid setting prices to undefined
      if (!updateData.prices) {
        delete updateData.prices;
      }

      // Handle images
      if (updateData.images || updateData.newImages) {
        const imageUrls = updateData.images ? [...updateData.images] : [];

        if (updateData.newImages && updateData.newImages.length > 0) {
          for (let i = 0; i < updateData.newImages.length; i++) {
            const file = updateData.newImages[i];
            if (file) {
              const path = `equipment/global/${Date.now()}_${i}`;
              const downloadURL = await uploadImage(file, path);
              imageUrls.push(downloadURL);
            }
          }
        }
        updateData.images = imageUrls;
      } else {
        delete updateData.images; // Avoid overwriting images if not provided
      }

      // Remove newImages from updateData as it's not a field in the database
      delete updateData.newImages;

      const equipmentRef = doc(db, "equipment", id);
      await updateDoc(equipmentRef, updateData);
      return { id, ...updateData };
    } catch (error) {
      console.error("Update equipment error:", error);
      throw new Error("Failed to update equipment");
    }
  }
};

export const getEquipment = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "equipment"));
    const equipmentList = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return equipmentList;
  } catch (error) {
    console.error("Get equipment error:", error);
    throw new Error("Failed to fetch equipment");
  }
};

export const deleteEquipment = async (id) => {
  try {
    const equipmentRef = doc(db, "equipment", id);
    await deleteDoc(equipmentRef);
  } catch (error) {
    console.error("Delete equipment error:", error);
    throw new Error("Failed to delete equipment");
  }
};
